import React from "react";
import RegisterForm from "../Auth/register";
import { Link } from "react-router-dom";

const RegisterPage = () => {
  return (
    <div style={{ width: "100%" }}>
      <div className="t-title">
        <h1>¡Registrate!</h1>
      </div>
      <div className="main">
        <RegisterForm />
        <br />
        <Link className="button button-secondary" to="/">
          Volver
        </Link>
      </div>
    </div>
  );
};

export default RegisterPage;
